import React, { ReactNode } from 'react';
import { styles } from './HeroBlock.css';
import { CardGrid, CardGridCardProps, CardGridVariant } from '../ContentCard/CardGrid/CardGrid';

export interface HeroBlockProps {
  heading?: ReactNode;
  cards?: Array<CardGridCardProps>;
  launchTiles?: ReactNode;
  footer?: ReactNode;
  breakToCarousel?: boolean;
  testId?: string;
}

export const HeroBlock: React.FC<HeroBlockProps> = ({
  heading,
  cards = [],
  launchTiles,
  footer,
  breakToCarousel = false,
  testId,
}) => {
  return (
    <div className={styles.container}>
      {heading ? <div className={styles.heading}>{heading}</div> : null}
      <CardGrid
        cards={cards}
        variant={CardGridVariant.withPrimary}
        isCarousel={breakToCarousel ? { xs: true, md: false } : false}
      />
      {launchTiles ? <div className={styles.launchTiles}>{launchTiles}</div> : null}
      {footer ? (
        <div className={styles.footer} data-testId={`${testId}-footer`}>
          {footer}
        </div>
      ) : null}
    </div>
  );
};
